export default {
    setSpotId(state, spotId) {
        state.spotId = spotId
    },
    getSpotId(state) {
        return state.spotId
    }
}
